// extracted by mini-css-extract-plugin
export default {"card":"CardIcon_card__q1TiF","icon":"CardIcon_icon__M5WlP","title":"CardIcon_title__4AO8K","value":"CardIcon_value__MycCu","footer":"CardIcon_footer__ofTMz"};